module.exports = __webpack_public_path__ + "img/promo-bg.900ff31.jpg";